import {IComponentController, IComponentOptions, IHttpResponse} from "angular";
import {Branch} from "../../model/Branch";
import './BranchElement.scss';
import {BranchUsersDialogComponent} from "../branch_users_dialog/branch-users.dialog.component";
import {BranchAddressDialogComponent} from "../branch-address-dialog/branch-address.dialog.component";
import {BranchesAddressService} from "../../../branches_service/service/branches-address.service";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import {
    BranchAddressServiceName,
    BranchesServiceName,
    ToastNotificationServiceName,
    UserServiceName
} from "../../../utils/names/serviceNames";
import {
    BranchUsersTransferDialogComponent
} from "../branch_users_transfer_dialog/branch_users_transfer.dialog.component";
import {BranchesService} from "../../../branches_service/service/branches-service";
import {UserService} from "../../../users_service/service/user.service";
import {BranchUsers} from "../../model/BranchUsers";
import {Address} from "../../../address/model/Address";


export class BranchElement implements IComponentController {

    public static instance: IComponentOptions = {
        controller: [
            '$mdDialog',
            BranchAddressServiceName,
            BranchesServiceName,
            UserServiceName,
            ToastNotificationServiceName,
            BranchElement
        ],
        template: require('./BranchElement.html'),
        bindings: {
            branch: '<',
            deleteBranchCallback: '<'
        }
    };

    private branch: Branch;
    private deleteBranchCallback: (branch: Branch) => void;
    private originatorEv: MouseEvent;
    private mousePressed: boolean = false;
    private loaderActive: boolean = false;


    constructor(private $mdDialog: angular.material.IDialogService,
                private branchesAddressService: BranchesAddressService,
                private branchService: BranchesService,
                private userService: UserService,
                private toastNotificationService: ToastNotificationService) {
    }

    touch = (status: boolean) => {
        console.log("branch touch:", status);
        this.mousePressed = status;
    };

    openMenu = ($mdMenu: angular.material.IMenuService, $event: MouseEvent) => {
        this.originatorEv = $event;
        $mdMenu.open($event);
    };

    openBranchUsersDialog = () => {
        this.$mdDialog.show(BranchUsersDialogComponent.instance(this.originatorEv, this.branch))
            .then(resp => {

            }, err => {

            });
    };

    openBranchAddressDialog = () => {
        let branch = this.branch;
        branch.address = branch.address ? branch.address : new Address();
        this.$mdDialog.show(BranchAddressDialogComponent.instance(this.originatorEv, branch))
            .then(updatedAddress => {
                    if (updatedAddress) {
                        this.toastNotificationService.generateSuccessMessage("Updated the branch address");
                        this.branch.address = updatedAddress
                    } else {
                        this.toastNotificationService.generateErrorMessage("Failed to update the branch address")
                    }
                },
                err => console.log(err)
            )
        ;
    };

    openDeleteBranchDialog = () => {
        this.fetchBranchUsers()
            .then(resp => this.handleUsersResponse(resp))
            .then(() => this.showConfirmDialog())
            .then(() => this.deleteBranch())
            .then(resp => this.handleDeleteResponse(resp));
    };

    private fetchBranchUsers() {
        this.loaderActive = true;
        return this.userService.getAllUsersOfTheBranch(this.branch);
    }

    private handleUsersResponse(resp: angular.IHttpResponse<BranchUsers[]>) {
        this.loaderActive = false;
        if (resp.status === 200) {
            if (resp.data.length) {
                return this.$mdDialog.show(BranchUsersTransferDialogComponent.instance(this.branch, resp.data))
            } else {
                return null;
            }
        } else {
            this.toastNotificationService.generateErrorMessage("Failed to fetch branch users");
            throw "Failed to fetch branch users";
        }
    }

    private showConfirmDialog() {
        return this.$mdDialog.show(
            this.$mdDialog.confirm()
                .ok("Yes")
                .cancel("Cancel")
                .title("Are you sure you want to delete branch " + this.branch.branchName + "?\nThis cannot be undone")
        );
    }

    private deleteBranch() {
        return this.branchService.deleteBranch(this.branch);
    }

    private handleDeleteResponse(resp: IHttpResponse<any>) {
        if (resp.status === 200) {
            this.toastNotificationService.generateSuccessMessage("Branch " + this.branch.branchName + " deleted");
            this.deleteBranchCallback(this.branch);
        } else {
            this.toastNotificationService.generateErrorMessage("Failed to delete branch");
        }
    }
}